import { ClubPage } from "components/ClubPage"
import { Text } from "components/Text"
import { useTranslator } from "components/Translator"
import { Wrapper } from "components/Wrapper"
import { GiftCard } from "domains/gift/GiftCard"
import { RawLink } from "components/Link"
import { TestimoniesSection } from "domains/testimony/TestimoniesSection"
import { PartnersSection } from "domains/partner/PartnersSection"
import { Card, CardContent } from "components/Card"
import { Button } from "components/Button"
import { useRouter } from "components/Router"
import { useConnectedUser } from "components/ConnectedUserProvider"
import * as User from "domains/user/model"

export function ClubGiftIndexPage({ gifts, testimonies, partners }) {
  const translator = useTranslator()
  const router = useRouter()
  const connectedUser = useConnectedUser()

  return (
    <ClubPage title={translator.trans("club.gift.index.title", null, "pages")}>
      <div className="py-5 lg:py-10">
        <Wrapper>
          {gifts.length > 0 ? (
            <div className="grid grid-cols-2 gap-2 md:grid-cols-3 lg:gap-4 lg:grid-cols-4">
              {gifts.map((gift) => (
                <RawLink
                  href={{
                    route: "app_club_shop_gift_show",
                    params: { giftId: gift.id },
                  }}
                  key={gift.id}
                >
                  <GiftCard gift={gift} />
                </RawLink>
              ))}

              {!connectedUser || !User.isClub(connectedUser) ? (
                <Card spacing="small">
                  <CardContent className={"h-full"}>
                    <div
                      className={"flex h-full flex-col justify-center gap-4"}
                    >
                      <Text
                        variant="headline5"
                        className="text-dark text-center"
                      >
                        {translator.trans("club.gift.index.subscribe.heading")}
                      </Text>

                      <div className={"flex justify-center"}>
                        <Button
                          href={router.generate("app_club_shop_plan_index")}
                        >
                          {translator.trans("club.gift.index.subscribe.cta")}
                        </Button>
                      </div>
                    </div>
                  </CardContent>
                </Card>
              ) : null}
            </div>
          ) : (
            <Text tag="p">
              {translator.trans("club.gift.index.empty", null, "pages")}
            </Text>
          )}
        </Wrapper>
      </div>
      <TestimoniesSection testimonies={testimonies} />
      <PartnersSection partners={partners} />
    </ClubPage>
  )
}
